import styled, { css } from 'styled-components'

import type { ThemeFontSize, ThemeFontWeight } from 'theme/theme'
import { fontFamily, fontSize, fontWeight, space } from 'theme/utils'

type TitleProps = {
  as?: 'h1' | 'h2'
  size?: Extract<ThemeFontSize, 'medium' | 'large' | 'xxLarge'>
}

export const Title = styled.h1.attrs({
  className: 'title',
})<TitleProps>`
  font-family: ${fontFamily('condensed')};
  line-height: 1.25em;

  font-weight: ${fontWeight('medium')};

  white-space: nowrap;

  ${({ size = 'large' }) => css`
    letter-spacing: ${size === 'xxLarge' ? '2px' : '1px'};
    font-size: ${fontSize(`${size}`)};
    &[data-fit-text] {
      font-size: calc(
        ${fontSize(`${size}`)} -
          (clamp(0, var(--fit-text-length) - 15, 20) * 0.31px)
      );
    }
  `}
`

type SubtitleProps = {
  as?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'strong'
  size?: Extract<ThemeFontSize, 'base' | 'medium' | 'xLarge'>
}

export const Subtitle = styled.h3.attrs({
  className: 'subtitle',
})<SubtitleProps>`
  font-family: ${fontFamily('base')};
  font-weight: ${fontWeight('medium')};

  white-space: nowrap;
  padding-left: ${space(1)};
  padding-right: ${space(1)};

  ${({ size = 'base' }) => css`
    font-size: ${fontSize(size)};
    &[data-fit-text] {
      font-size: calc(
        ${fontSize(`${size}`)} -
          (clamp(0, var(--fit-text-length) - 15, 20) * 0.3px)
      );
    }
  `}
`

type HeadingProps = {
  as?: 'h2' | 'h3'
  size?: Extract<ThemeFontSize, 'xLarge' | 'medium'>
  weight?: Extract<ThemeFontWeight, 'bold' | 'base' | 'medium'>
  pad?: boolean
}

export const Heading = styled.h2.attrs({
  className: 'heading',
})<HeadingProps>`
  font-family: ${fontFamily('base')};
  line-height: 0.9em;
  text-transform: uppercase;
  width: 100%;

  ${({ size = 'xLarge', weight = 'bold', pad = false }) => css`
    --font-size: ${fontSize(size)};
    font-size: var(--font-size);
    font-weight: ${fontWeight(weight)};
    padding: ${pad ? `0 ${space(5)}` : '0'};
  `}

  @container title (max-width: 300px) {
    font-size: calc(var(--font-size) * 0.65);
  }

  @container title (max-width: 180px) {
    font-size: calc(var(--font-size) * 0.55);
  }
`

export const TitleContainerQuery = css`
  container-type: inline-size;
  container-name: title;
`
